import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  errorMessage: null,
  message: null,
  show: false,
});

export const closeNotification = createAction('CLOSE_NOTIFICATION');
export const errorNotification = createAction('ERROR_NOTIFICATION');
export const successNotification = createAction('SUCCESS_NOTIFICATION');

const reducers = createReducer({
  [errorNotification]: (state, errorMessage) => state.merge({ errorMessage, message: null, show: true }),
  [successNotification]: (state, message) => state.merge({ message, errorMessage: null, show: true }),
  [closeNotification]: state => state.merge({ show: false }),
}, INITIAL_STATE);

export default reducers;
